import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle_close",
  "use": "circle_close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle_close\">\n<path d=\"M13.75 7.00536L12.9946 6.25L10 9.24464L7.00536 6.25L6.25 7.00536L9.24464 10L6.25 12.9946L7.00536 13.75L10 10.7554L12.9946 13.75L13.75 12.9946L10.7554 10L13.75 7.00536Z\" fill=\"#616161\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"9.5\" stroke=\"#616161\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol